import { render, staticRenderFns } from "./CollaboratorRow.vue?vue&type=template&id=dd5c6390&scoped=true&"
import script from "./CollaboratorRow.vue?vue&type=script&lang=js&"
export * from "./CollaboratorRow.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorRow.vue?vue&type=style&index=0&id=dd5c6390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5c6390",
  null
  
)

export default component.exports